import { createApp } from "vue";
import hash from "../../hash";
import { ModalHelper } from "../../B2bTools";
import { traduit } from "../composant/b2bLangue";

import html from "./brandnameList.html";
import htmlBrandnameEdit from "./brandname@edit.html";

import Fuse from 'fuse.js'
const fuseOptions = {
    threshold: 0.0,
    keys: [
        'v',
        'buyersSearch'
    ]
}

const js = ({
    url: function (echangeur) {
        echangeur.addAction('b2b.brandname.list', {}, '', 'brandname');
        echangeur.addAction('b2b.codification.select', { classe: "market" }, '', 'market');
        echangeur.addAction('b2b.env.get', echangeur.hash, '', 'univers');
    },
    onLoad: function (echangeur) {
        let THIS = this;

        let env =echangeur.univers.env;
        // orderdepartments  : 
        // [{orderdepartment: "BAGS-SLG",…},…] 
        // {orderdepartment: "BAGS-SLG",…} 
        // {orderdepartment: "KSHOES", buyers: ["buyer2", "buyer1"], team: "Retail europe"} 
        // {orderdepartment: "MSHOES", buyers: ["buyer3@tata.fr", "buyerporter@dede.com"], team: "zdazda"} 
        // {orderdepartment: "WSHOES", buyers: ["buyer99@acs2i.fr", "63c56331e4a24811204be495"], team: "ADV"} 
        // {orderdepartment: "MKTG", buyers: [], team: "63651cfc5a162017882c094c"}

        for(let d of echangeur.brandname.rows){

            let sBuyers = new Set();

            d.orderdepartments.map(u=>{
                u.buyers.map(e=>{
                    sBuyers.add(e)
                });
            })


            // 63c56331e4a24811204be495  {k: "tin@tin.cn", status: "D", _id: "63c56331e4a24811204be495"}
            let buyers = Array.from(sBuyers)
            d.buyersSearch =  buyers.map(u=>{
                return (d.buyers[u].k);
            })
            d.buyersAff = Array.from(d.buyersSearch ).join(", ");
            // d.buyers    = Array.from(sBuyers);
        }

        const app = createApp({
            data: () => ({
                datas: echangeur.brandname.rows,
                isEdi: env.edi,
                env: env.k,
                // fuse: null,
                // search: null,
                // searchKey: null
                fuse: null,
                searchKey: '',
            }),
            methods: {
                edit(item) {
                    hash.lance("brandname", { _id: item._id , u: this.env+""});
                },

                toClients(array) {
                    return array.map(u => u.k).join(', ')
                },

                toOrderdepartments(array) {
                    return array.map(u => u.orderdepartment).join(', ')
                },

                toReps(array) {
                    return array?.map(u => u).join(', ')
                },

                lanceRecherche(val) {
                    const index = 'v'
                    const data = this.datas
                    if (data && val) {
                        const searchIndex = this.fuse.search(val).map(u => u.item[index]);
                        data.map(u => u.inSearch = (searchIndex.includes(u[index])))
                    }
                },
                // lanceRecherche(val) {
                //     this.search = this.fuse.search(val);
                //     let indexSearch = this.search.map(e => {
                //         return e.item._id;
                //     });
                //     let countUserAff = 0;
                //     this.datas.map(u => {
                //         u.inSearch = (indexSearch.indexOf(u._id) > -1);
                //         if (u.show) countUserAff += 1;
                //     })
                //     if (this.allSelected && indexSearch.length != countUserAff) this.allSelected = false;
                // },

                brandnameCreate() {
                    const thisParent = this;
                    const modaleApp = createApp({
                        data: function () {
                            return {
                                datas: [],
                                error: { v: "" },
                                saisie:""  
                            }
                        },
                        methods: {
                            close: function () {
                                ModalHelper.hide();
                            },
                            reset() {
                                this.error.v = false
                            },
                            async save() {
                                const thisVue = this;
                                this.reset()

                                function nbe(object) {
                                    let nb = 0;
                                    for (let key in object) if (object[key]) nb++;
                                    return nb;
                                }
                                const form = {
                                    "v": this.saisie,
                                }
                                if (!form.v) this.error.v = "Required"
                                if (!nbe(this.error)) {
                                    form.env = this.env;
                                    const retour = await THIS.rest("b2b.brandname.create", {}, form);
                                    this.close();
                                    hash.lance("brandname", { _id: retour.doc._id,  env});
                                }
                            },
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlBrandnameEdit).container);
                }, 
                t(value) {
                    return traduit(value, 'global');
                }
            },
            watch: {
                "searchKey"(val) {
                    this.lanceRecherche(val);
                }
            },
            mounted() {
                this.fuse = new Fuse(this.datas, fuseOptions);
                //this.fuse = new Fuse(this.datas, { includeScore: false, threshold: 0.2, keys: ['v', 'k', 'market'] });
            }
        });
        app.mount(THIS.c$('._vueChargement')[0]);
    },

});

export default {
    brandnameList: { js: js, html: html }
};